<template>
    <v-dialog
        v-model="dialog"
        max-width="450"
        persistent
    >
        <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                >
                    {{nombre}}
                </v-card-title>
                <v-card-text class="pt-2">
                    <!-- ---------------------------------------------------- -->
                    <v-row class="text-center" no-gutters>
                        <v-col cols="12">
                            <v-slider v-model="valor" min="0" max="10"></v-slider>
                        </v-col>
                        <v-col cols="12" align="center">
                            <v-img
                                height="50"
                                width="50"
                                :src="escalaImagen"
                            />
                            {{escalaText}}: {{valor}}
                        </v-col>
                        <v-col cols="12" align="center">
                            <v-text-field
                                v-model="observaciones"
                                filled
                                rounded
                                clearable
                                dense
                                label="Observaciones"
                            ></v-text-field>
                        </v-col>

                    </v-row>

                    <!-- ---------------------------------------------------- -->
                </v-card-text>

                <v-card-actions>
                    
                    <v-btn
                        color="success"
                        :loading="loading"
                        @click="agrega"
                    >
                        Agregar
                    </v-btn>
                    
                    <v-btn color="error" @click="cancela">
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>
export default {
    props:{
        dialogDe:Boolean,
        turno:String,
        nombre:String,
        estaFecha: String,
        internamiento:Number,
    },

    data:()=>({
        loading:false,
        valor:0,
        observaciones:'',
    }),

    computed:{
        dialog:{
            get(){
                return this.dialogDe
            },
            set(val){
                this.$emit('update:dialogDe',val)
            },
        },
        escalaImagen(){
            let text = ''
            if (this.valor == 0)
                text='/images/escalas/dolor-1.png'
            if (this.valor >0 && this.valor <=2)
                text='/images/escalas/dolor-2.png'
            if (this.valor >2 && this.valor <=4)
                text='/images/escalas/dolor-3.png'
            if (this.valor >4 && this.valor <=6)
                text='/images/escalas/dolor-4.png'
            if (this.valor >6 && this.valor <=8)
                text='/images/escalas/dolor-5.png'
            if (this.valor >8)
                text='/images/escalas/dolor-6.png'

            return text
        },
        escalaText(){
            let text = ''
            if (this.valor == 0)
                text='Sin dolor'
            if (this.valor >0 && this.valor <=2)
                text='Poco dolor'
            if (this.valor >2 && this.valor <=4)
                text='Dolor moderado'
            if (this.valor >4 && this.valor <=6)
                text='Dolor fuerte'
            if (this.valor >6 && this.valor <=8)
                text='Dolor muy fuerte'
            if (this.valor >8)
                text='Dolor insoportable'

            return text
        }
    },
    methods:{
        cancela(){
            this.observaciones = ''
            this.dialog = false
        },
         async agrega(){


            this.loading=true

            let datos = {
                fecha: this.estaFecha,
                turno: this.turno,
                escala: 'dolor',
                valor: this.valor,
                internamiento:this.internamiento,
                observaciones: this.observaciones,
            }
            try{
                let dt = await this.$http({
                    url:'/enfermeria/guardaEscalas',
                    method: 'POST',
                    data: datos
                })
                if (dt.data.estado == true){
                    this.$emit('escalaSuccess')
                    this.observaciones = ''
                    this.valor = 0
                    this.loading = false
                    this.dialog = false
                } else {
                    console.log(dt.data)
                    this.loading = false
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'No se puede guardar',
                        text: 'Verifique los datos e intente de nuevo',
                    })
                }
                
            } catch(err){
                console.log(err)
                this.$store.dispatch('security/revisaError',err)
                this.loading = false
            }
        },
    },
}
</script>

<style>

</style>